// extracted by mini-css-extract-plugin
export default {"name":"ModalShareCatalogue_name__7JxfS","inputAndButton":"ModalShareCatalogue_inputAndButton__HLbx4"};